var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefault = function SvgDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#default_svg__a)",
    d: "m43.45 30.14 17.686 19.542H43.45v8.364h25.26l4.626-8.364L43.45 16.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#default_svg__b)",
    d: "M33.651 19.872 6.667 49.682l4.625 8.364h25.26v-8.364h-17.69l17.69-19.542V16.666z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "default_svg__a",
    x1: 30.986,
    x2: 83.539,
    y1: 1.149,
    y2: 39.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14497B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "default_svg__b",
    x1: -5.798,
    x2: 46.755,
    y1: 1.149,
    y2: 39.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14497B"
  })))));
};
export { SvgDefault as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQzLjQ1MDUgMzAuMTM5OUw2MS4xMzU4IDQ5LjY4MjJINDMuNDUwNVY1OC4wNDU4SDY4LjcxMDNMNzMuMzM1NiA0OS42ODIyTDQzLjQ1MDUgMTYuNjY2NVYzMC4xMzk5WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzQ0MV8xMDk1KSIvPgo8cGF0aCBkPSJNMzMuNjUxMSAxOS44NzIyTDYuNjY2NjYgNDkuNjgyMkwxMS4yOTIgNTguMDQ1OEgzNi41NTE3VjQ5LjY4MjJIMTguODYxN0wzNi41NTE3IDMwLjEzOTlWMTYuNjY2NUwzMy42NTExIDE5Ljg3MjJaIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXJfNDQxXzEwOTUpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNDQxXzEwOTUiIHgxPSIzMC45ODYxIiB5MT0iMS4xNDkyNiIgeDI9IjgzLjUzOSIgeTI9IjM5LjEwNDEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzVCQTRFQSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxNDQ5N0IiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyXzQ0MV8xMDk1IiB4MT0iLTUuNzk3NzgiIHkxPSIxLjE0OTI2IiB4Mj0iNDYuNzU1MSIgeTI9IjM5LjEwNDEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzVCQTRFQSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxNDQ5N0IiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";